import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import VueTimeago from 'vue-timeago';
import HighchartsVue from 'highcharts-vue';
import vco from 'v-click-outside';
import panZoom from 'vue-panzoom';
import vSelect from 'vue-select';
import store from './state/store';
import router from './router/index';

import './assets/app.scss';

import App from './App.vue';

import i18n from './i18n';

import 'vue-select/dist/vue-select.css';
// install plugin
Vue.use(panZoom);

const options = {
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  hideProgressBar: true,
  maxToasts: 1,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
};

Vue.use(Toast, options);
Vue.use(VueTimeago, {
  locale: 'en-US',
});

Vue.use(VueRouter);
Vue.use(vco);
Vue.use(BootstrapVue);
Vue.use(HighchartsVue);
Vue.component('v-select', vSelect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
